'use strict';

(function ($, Drupal, once) {
  Drupal.behaviors.articleListingV2 = {
    attach: function (context) {
      $(once('articleListingV2', '.view-article-listing-v2, .view-event-listing-v2', context)).each(function () {
        var $view = $(this);

        $('#views-exposed-form-article-listing-v2-filtered-page, #views-exposed-form-event-listing-v2-filtered-page', $view).each(function () {
          var $form = $(this);
          var gtm_data = {};

          $('.form-item-search input[type="text"]', $form).on('focus', function(){
            $(this).parent().addClass('focused');
          }).on('blur', function() {
            $(this).parent().removeClass('focused');
          });

          var $result_count = $('.view-header .result-count > div', $view);
          var $filter_button_wrapper = $('<div class="filter-wrapper"></div>');
          var $filter_button = $('<button aria-controls="' + $form.attr('id') + '" aria-expanded="false"><div><span>Filter Content</span></div></button>');

          $filter_button
            .on('click', function() {
              if ($filter_button.attr('aria-expanded') == 'false') {
                $filter_button.attr('aria-expanded', 'true');
                $('span', $filter_button).text('Close Filter');
                $form.attr('aria-hidden', 'false').show();
              }
              else {
                $filter_button.attr('aria-expanded', 'false');
                $('span', $filter_button).text('Filter Content');
                $form.attr('aria-hidden', 'true').hide();
              }
            })
            .appendTo($filter_button_wrapper);
          $form.appendTo($filter_button_wrapper);
          $filter_button_wrapper.appendTo($result_count);

          var $link_divs = $('<div/>', {'class': 'selected-filters'});
          $link_divs.insertBefore($('#edit-actions', $form));

          // Find all possible matches in case other slots were added by other code.
          $link_divs = $('.selected-filters', $view);

          var foundSelected = false;
          $form.find('input[type="text"], input[type="checkbox"], input[type="radio"], select').each(function () {
            var $target = $(this);
            var data_name = $target.attr('id').replace(/^(edit-)/, '');

            if ($target.is('select')) {
              if ($target.val() !== '' && $target.val() !== 'All') {
                $('<span class="selected-filter" data-target="' + $target.attr('id') + '" onclick="document.getElementById(this.dataset.target).selectedIndex = 0; jQuery(\'#\' + this.dataset.target).closest(\'form\').trigger(\'submit\')">' + $target.find('option:selected').text() + '</span>').appendTo($link_divs);
                foundSelected = true;

                data_name = $target.attr('id').replace(/^(edit-)/, '');
                gtm_data[data_name + '_values'] = $target.find('option:selected').map(function (option) {
                  return $(option).text();
                });
                gtm_data[data_name] = gtm_data[data_name + '_values'].join('|');
              }
            }
            else if ($target.is('input')) {
              if ($target.is('[type="text"]')) {
                var text = String($target.val());
                text = text.replace(/['"]+/g, '').trim();
                text = Drupal.checkPlain(text).trim();
                if (text) {
                  $('<span class="selected-filter" data-target="' + $target.attr('id') + '" onclick="jQuery(\'#\' + this.dataset.target).val(\'\').closest(\'form\').trigger(\'submit\')">"' + text + '"</span>').appendTo($link_divs);
                  foundSelected = true;

                  data_name = $target.attr('id').replace(/^(edit-)/, '');
                  gtm_data[data_name] = text;
                  gtm_data[data_name + '_values'] = [text];
                }
              }
              else if ($target.is(':checked')) {
                var label = $target.next('label').text();
                if (label !== '- Any -') {
                  $('<span class="selected-filter" data-target="' + $target.attr('id') + '" onclick="jQuery(\'#\' + this.dataset.target).prop(\'checked\', false).closest(\'form\').trigger(\'submit\')">' + label + '</span>').appendTo($link_divs);
                  foundSelected = true;

                  data_name = $target.attr('id').replace(/^(edit-)/, '');
                  var $checkboxes_wrapper = $target.closest('.form-checkboxes');
                  if ($checkboxes_wrapper.length) {
                    data_name = $checkboxes_wrapper.attr('id')
                                .replace(/^(edit-)/, '')
                                .replace(/(--wrapper)$/, '');
                  }

                  gtm_data[data_name + '_values'] = gtm_data[data_name + '_values'] || [];
                  gtm_data[data_name + '_values'].push(label);
                  gtm_data[data_name] = gtm_data[data_name + '_values'].join('|');
                }
              }
            }
          });

          if (foundSelected) {
            $link_divs.addClass('has-selected');
            var $resetElem = $('#edit-reset', $form);
            if ($resetElem.length) {
              $('<span class="selected-filter-clear" onclick="jQuery(\'#edit-reset\').trigger(\'click\')">Clear all filters</span>').appendTo($link_divs);
            }
          }

          $form.submit(function () {
            var $form = $(this);

            var $topics = $form.find('#edit-tags input:checked').map(function () {
              return this.value;
            }).get();

            var $program = $form.find('#edit-program input:checked').map(function () {
              return this.value;
            }).get();

            var $audience = $form.find('#edit-audience input:checked').map(function () {
              return this.value;
            }).get();

            dataLayer.push({
              'formLocation': 'news-events',
              'event': 'search',
              'category': 'Engagement',
              'label': 'Newsroom Filter',
              'action': 'text: ' + $form.find('#edit-search').val() + ' topic: ' + $topics + ' program: ' + $program + ' audience: ' + $audience
            });
          });

          // Push form values into the GTM data layer.
          if (Object.keys(gtm_data).length) {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push(gtm_data);
          }
        });
      });
    }
  }
})(jQuery, Drupal, once);
